import request from '../utils/request'

// 列表
export function customerAppListApi (data, cancelToken) {
  return request({
    url: '/api/arsCustomer/queryAppList',
    method: 'post',
    data,
    cancelToken
  })
}

export function dictDetailMapApi (data) {
  return request({
    url: `/api/dictDetail/map?dictName=${data}`,
    method: 'get'
  })
}
export function deptTreeDeptApi () {
  return request({
    url: 'api/dept/treeDept',
    method: 'get'
  })
}

export function getOssTokenApi () {
  return request({
    url: '/api/commonFile/getOssToken',
    method: 'get'
  })
}

// 首页
export function arsAppHomeApi () {
  return request({
    url: 'api/home/appHome',
    method: 'get'
  })
}
// 产品列表
export function arsProductListApi () {
  return request({
    url: 'api/arsProduct/productList',
    method: 'get'
  })
}
// 门店列表
export function arsCustomerAppListPageApi (data) {
  return request({
    url: 'api/customer/appListPage',
    method: 'post',
    data
  })
}
// 门店新增
export function arsAddCustomerApi (data) {
  return request({
    url: 'api/customer/addCustomer',
    method: 'post',
    data
  })
}
// 门店编辑
export function arsUpdateCustomerApi (data) {
  return request({
    url: 'api/customer/updateCustomer',
    method: 'post',
    data
  })
}
// 门店详情
export function arsCustomerInfoApi (customerId) {
  return request({
    url: `api/customer/info/${customerId}`,
    method: 'get'
  })
}
export function arsCustomerUpdateInfoApi (customerId) {
  return request({
    url: `api/customer/updateInfo?customerId=${customerId}`,
    method: 'get'
  })
}

export function arsOperationActionListPageApi (data) {
  return request({
    url: 'api/operationAction/listPage',
    method: 'post',
    data
  })
}

// 地图
export function arsCustomerAppMapListPageApi (data, cancelToken) {
  return request({
    url: 'api/customer/appMapListPage',
    method: 'post',
    data,
    cancelToken
  })
}

export function arsScheduleListPageApi (params) {
  return request({
    url: 'api/home/scheduleListPage',
    method: 'get',
    params
  })
}

// 员工激励 -----------------------------------------
export function arsEmployeeListPageApi (params) {
  return request({
    url: 'api/activityEmployee/employeeListPage',
    method: 'get',
    params
  })
}
export function arsActivityOrderAppListPageApi (data) {
  return request({
    url: 'api/activityOrder/appListPage',
    method: 'post',
    data
  })
}

export function arsAddOrUpdateEmployeeApi (data) {
  return request({
    url: 'api/activityEmployee/addOrUpdateEmployee',
    method: 'post',
    data
  })
}

export function arsSmsTextApi (id) {
  return request({
    url: `api/activityEmployee/smsText/${id}`,
    method: 'get'
  })
}

export function arsSendSmsTextApi (id) {
  return request({
    url: `api/activityEmployee/sendSmsText/${id}`,
    method: 'post'
  })
}

export function arsActivityEmployeeInfoApi (employeeId) {
  return request({
    url: `api/activityEmployee/info/${employeeId}`,
    method: 'get'
  })
}

export function arsDeleteEmployeeApi (data) {
  return request({
    url: 'api/activityEmployee/deleteEmployee',
    method: 'post',
    data
  })
}

export function arsActivityQrCodeApi (customerId) {
  return request({
    url: `api/activity/qrCode/${customerId}`,
    method: 'get'
  })
}

export function arsActivityRedeemListApi () {
  return request({
    url: 'api/activity/redeemList',
    method: 'get'
  })
}

export function arsActivityOrderRedeemApi (data) {
  return request({
    url: 'api/activityOrder/redeemOrder',
    method: 'post',
    data
  })
}

export function activityEmployeeQrCodeApi (employeeId) {
  return request({
    url: `api/activityEmployee/qrCode/${employeeId}`,
    method: 'get'
  })
}

export function customerActivityLogPageApi (data) {
  return request({
    url: 'api/customer/activityLogPage',
    method: 'post',
    data
  })
}

export function sdActivityLogPageApi (data) {
  return request({
    url: 'api/sd/activityLogPage',
    method: 'post',
    data
  })
}
